import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'sb-navigation-buttons',
  templateUrl: './navigation-buttons.component.html',
  styleUrls: ['./navigation-buttons.component.scss']
})
export class NavigationButtonsComponent {

  @Output() backClick = new EventEmitter();
  @Output() submitClick = new EventEmitter();
  @Output() closeClick = new EventEmitter();
  @Input() hasBack = true;
  @Input() showCloseButton = false;
  @Input() submitDisabled = false;
  @Input() showPaypalContainer = false;
  @Input() showUpperContainer = false;
  @Input() hasSubmit = true;
  @Input() text = 'STEP.ACTIONS.GO-NEXT';
  @Input() isSticky = false;
  @Input() isStickyHide = true;
  goToPreviousStep() {
    this.backClick.emit();
  }

  onCloseButton() {
    this.closeClick.emit();
  }

  onSubmit() {
    if (this.submitDisabled) { return; }
    this.submitClick.emit();
  }

}
